import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { TfiCheck } from 'react-icons/tfi';
import EmailsWidget from '../../components/emailsWidget';
import OsWidget from '../../components/osWidget';
import TopBanner from '../../components/topBanner';
import VpsPlansWidget from '../../components/vpsPlansWidget';
import FeaturesWidget from '../../components/featuresWidget';
import FaqWidget from '../../components/faqWidget';
import VpsPlansBottomWidget from '../../components/vpsPlansBottomWidget';
import ContactBanner from '../../components/contactBanner/ContactBanner';
import vpsBanner from '../../assets/img/vps-banner.svg';
import releaseIcon from '../../assets/img/release-icon.svg';
import checkmarkIcon from '../../assets/img/checkmark.svg';
import infoBanner1 from '../../assets/img/info-banner-1.svg';
import infoBanner2 from '../../assets/img/info-banner-2.svg';
import infoBanner3 from '../../assets/img/info-banner-3.svg';
import { SmoothScrollLink } from '../../utils/navUtils';
import './vps.scss';

function VpsPage() {
    const { i18n, t } = useTranslation();
    const currentLanguage = i18n.language;
    const localizedPath = (path) => {
        const baseLangUrl = `/${currentLanguage}`;
        return baseLangUrl + path;
    };

    return (
        <>
            <Helmet>
                <title>{t('titles.vps')}</title>
            </Helmet>
            <div className="vps-page-wrapper">
                <TopBanner
                    bannerImage={<img src={vpsBanner} alt="VPS banner" />}
                    className="web-top-banner"
                >
                    <>
                        <h1 className="banner-header">{t('vps-page.top-banner.title')}</h1>
                        <h2
                            className="banner-sub-header"
                            dangerouslySetInnerHTML={{
                                __html: t('vps-page.top-banner.text')
                            }}
                        />
                        <ul className="banner-list">
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">{t('vps-page.top-banner.list-1')}</p>
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">{t('vps-page.top-banner.list-2')}</p>
                            </li>
                            <li className="banner-item">
                                <img src={releaseIcon} alt="List item" />
                                <p className="banner-text">{t('vps-page.top-banner.list-3')}</p>
                            </li>
                        </ul>
                        <div className="banner-actions">
                            <Nav>
                                <SmoothScrollLink to={localizedPath('/vps-server#plans-section')}>
                                    <Navbar.Brand>{t('buttons.order-vps')}</Navbar.Brand>
                                </SmoothScrollLink>
                            </Nav>
                            <div className="action-info">
                                <img src={checkmarkIcon} alt="Checkmark" />
                                <p className="action-text">{t('banners.top-banner-money-back')}</p>
                            </div>
                        </div>
                    </>
                </TopBanner>
                <section className="info-banner">
                    <Container>
                        <Row>
                            <Col lg={4}>
                                <div className="info-banner-block">
                                    <img
                                        className="info-image"
                                        src={infoBanner1}
                                        alt="Info banner"
                                    />
                                    <h3 className="info-banner-title">
                                        {t('banners.info-banner-web.col-1-text')}
                                    </h3>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="info-banner-block">
                                    <img
                                        className="info-image"
                                        src={infoBanner2}
                                        alt="Info banner"
                                    />
                                    <h3 className="info-banner-title">
                                        {t('banners.info-banner-web.col-2-text')}
                                    </h3>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="info-banner-block">
                                    <img
                                        className="info-image"
                                        src={infoBanner3}
                                        alt="Info banner"
                                    />
                                    <h3 className="info-banner-title">
                                        {t('banners.info-banner-web.col-3-text')}
                                    </h3>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section className="section-wrapper plans-section" id="plans-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('vps-page.vps-plans-title')
                                }}
                            />
                            <div className="section-subtitles">
                                <Row>
                                    <Col lg={4} md={6} xs={12}>
                                        <h3 className="single-subtitle">
                                            <TfiCheck color="#00af60" />
                                            {t('vps-page.vps-subtitle-1')}
                                        </h3>
                                    </Col>
                                    <Col lg={4} md={6} xs={12}>
                                        <h3 className="single-subtitle">
                                            <TfiCheck color="#00af60" />
                                            {t('vps-page.vps-subtitle-2')}
                                        </h3>
                                    </Col>
                                    <Col lg={4} md={6} xs={12}>
                                        <h3 className="single-subtitle">
                                            <TfiCheck color="#00af60" />
                                            {t('vps-page.vps-subtitle-3')}
                                        </h3>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <VpsPlansWidget />
                    </Container>
                </section>
                <section className="section-wrapper features-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('vps-page.features-title')
                                }}
                            />
                            <p className="section-text">{t('vps-page.features-text')}</p>
                        </div>
                        <FeaturesWidget dataType="vps" />
                    </Container>
                </section>
                <section className="section-wrapper os-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('vps-page.os-title')
                                }}
                            />
                            <p className="section-text">{t('vps-page.os-text')}</p>
                        </div>
                        <OsWidget />
                    </Container>
                </section>
                <section className="section-wrapper emails-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('vps-page.vps-title')
                                }}
                            />
                            <p className="section-text">{t('vps-page.vps-text')}</p>
                        </div>
                        <EmailsWidget dataType="vps" />
                    </Container>
                </section>
                <section className="regular-banner p-5">
                    <h3 className="banner-title">{t('banners.regular-banner-vps-text')}</h3>
                </section>
                <section className="section-wrapper extended-plans-section" id="all-plans-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('vps-page.vps-bottom-plans-title')
                                }}
                            />
                            <p className="section-text">{t('vps-page.vps-bottom-plans-text')}</p>
                        </div>
                        <VpsPlansBottomWidget />
                    </Container>
                </section>
                <section className="section-wrapper faq-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('vps-page.faq-title')
                                }}
                            />
                            <p className="section-text">{t('vps-page.faq-text')}</p>
                        </div>
                        <FaqWidget dataType="vps" />
                    </Container>
                </section>
                <ContactBanner />
            </div>
        </>
    );
}

export default VpsPage;
